export default "__VITE_ASSET__djlA6I_w__"